<template>
  <v-row v-if="getShowDemoApp">
    <v-dialog
      v-model="getShowDemoApp"
      fullscreen
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card
        class="pa-0 d-flex flex-column-reverse"
        color="primary"
        style="position: relative"
        outlined
      >
        <div class="iframe-container">
          <iframe
            src="https://elpaso-kiosks.arsconnect.com/"
            allow="camera; microphone"
            width="1920px"
            height="1080px"
          ></iframe>
        </div>
        <v-btn
          color="red"
          dark
          class="mx-auto my-6 white--text text-h6"
          width="275"
          x-large
          @click="closeDemoApp"
        >
          <v-icon left large class="px-4">mdi-close</v-icon>
          Exit Demo Mode
        </v-btn>
      </v-card>
    </v-dialog>
  </v-row>

  <v-row v-else no-gutters class="mt-2">
    <div v-if="!getShowDemoApp" class="floating-demo-btn d-flex">
      <v-btn
        height="100"
        width="82"
        color="primary"
        class="d-flex flex-column justify-center rounded-r-xl"
        @click="openPasscodeDialog()"
      >
        <span class="text-h6 text-white d-block"
          >Demo <br />
          Mode</span
        >
      </v-btn>
    </div>

    <v-col cols="6" v-if="!getShowDemoApp">
      <!-- <v-btn>Here</v-btn> -->
      <avatar
        :initialWidth="avatarWidth"
        ref="mainAvatar"
        :key="avatarKey"
      ></avatar>
    </v-col>
    <v-col cols="6">
      <menuMatrix></menuMatrix>
    </v-col>

    <v-dialog v-model="getPassCodeDialog" max-width="350">
      <v-card color="#F3EFE7">
        <v-card-title class="justify-center text-h4 ma-2">
          Enter Passcode
        </v-card-title>

        <v-card-text>
          <!-- Passcode Display -->
          <v-text-field
            :value="maskedPasscode"
            label="Passcode"
            readonly
            hide-details
            solo
            class="mb-2 text-center text-h6"
            append-icon="mdi-backspace"
            @click:append="deleteLastDigit"
          ></v-text-field>

          <div style="min-height: 24px" class="text-center">
            <span v-if="showWarning" class="red--text text-subtitle-2 mb-2">
              Incorrect passcode. Please try again.
            </span>
          </div>

          <!-- Numeric Keypad -->
          <v-row no-gutters justify="center" class="keypad">
            <v-col
              v-for="n in 9"
              :key="n"
              cols="4"
              class="d-flex justify-center pa-1"
            >
              <v-btn fab color="primary" @click="appendDigit(n)">
                <span class="text-h6">{{ n }}</span>
              </v-btn>
            </v-col>

            <v-col cols="4" class="d-flex justify-center pa-1"></v-col>
            <v-col cols="4" class="d-flex justify-center pa-1">
              <v-btn fab color="primary" @click="appendDigit(0)">
                <span class="text-h6">0</span>
              </v-btn>
            </v-col>
            <v-col cols="4" class="d-flex justify-center pa-1"></v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error text-white" @click="closePassCodeDialog"
            >Cancel</v-btn
          >
          <v-btn
            color="primary text-white"
            @click="submitPasscode"
            :disabled="!passcode.length"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import avatar from "@/components/avatar.vue";
import menuMatrix from "@/components/menuMatrix.vue";
import { mapGetters } from "vuex";
import languageBar from "@/components/languageBar.vue";

export default {
  name: "Home",
  data() {
    return {
      // passcodeDialog: false,
      passcode: "",
      passcodeLength: 4,
      avatarKey: 0,
      showWarning: false,
      // showDemoApp: false,
    };
  },
  components: {
    avatar,
    menuMatrix,
    languageBar,
  },
  computed: {
    ...mapGetters([
      "getPassCodeDialog",
      "appDimensions",
      "getShowDemoApp",
      "getenableADA",
      "getAvatarID",
      "getTouchCount",
      "isUserLooking",
      "getKioskProfile",
      "getSessionId",
    ]),
    avatarWidth() {
      console.log("Avatar Width: ", this.appDimensions.width / 2);
      return this.appDimensions.width / 1.8;
      // return 800
    },
    maskedPasscode() {
      return "*".repeat(this.passcode.length);
    },
  },
  methods: {
    goDemo() {
      console.log("Going to Demo Mode");
      // this.showDemoApp = true;
      this.$store.commit("setShowDemoApp", true);
      var date = new Date();
      this.$store.dispatch("addSessionDataToStrapi", {
        applicationId: this.getKioskProfile.data().applicationId,
        actionType: "Touch",
        applicationSessionId: this.getSessionId,
        timeStamp: date.toISOString(),
        sessionPayload: {
          module: "Home Page",
          action: "navigate",
          response: "Open Demo App",
          timeStamp: date.toISOString(),
        },
      });

      this.$store.dispatch("addInteractionToPostgres", {
        actionType: "Interaction",
        actionPayload: {
          module: "Home Page",
          navigateFrom: "Home Page",
          navigateTo: "Open Demo App",
          interactionType: "Touch",
          elementContent: "Open Demo App",
        },
      });
    },

    closePassCodeDialog() {
      this.passcode = "";
      this.showWarning = false;
      this.$store.commit("setPassCodeDialog", false);
    },

    closeDemoApp() {
      // this.showDemoApp = false;
      this.$store.commit("setShowDemoApp", false);

      var date = new Date();
      this.$store.dispatch("addSessionDataToStrapi", {
        applicationId: this.getKioskProfile.data().applicationId,
        actionType: "Touch",
        applicationSessionId: this.getSessionId,
        timeStamp: date.toISOString(),
        sessionPayload: {
          module: "Home Page",
          action: "navigate",
          response: "Exit Demo App",
          timeStamp: date.toISOString(),
        },
      });

      this.$store.dispatch("addInteractionToPostgres", {
        actionType: "Interaction",
        actionPayload: {
          module: "Demo",
          navigateFrom: "Demo App",
          navigateTo: "Home Page",
          interactionType: "Touch",
          elementContent: "Exit Demo App",
        },
      });

      console.log("avatar id:", this.getAvatarID);

      // this.$store.dispatch("loadAvatar");
      this.$nextTick(() => {
        // This will trigger the script injection into 'divVHSS'
        console.log("Re-loading Avatar after Demo...");
        this.$store.dispatch("loadAvatar");
      });
    },

    openPasscodeDialog() {
      this.passcode = "";
      // this.passcodeDialog = true;
      this.$store.commit("setPassCodeDialog", true);
      var date = new Date();
      if (!this.isUserLooking) {
        this.$store.commit("setTouchCount", this.getTouchCount + 1);
        console.log(this.getTouchCount, " this is the touchCount in MM");
        if (this.getTouchCount === 1) {
          this.$store.dispatch("addSessionDataToStrapi", {
            applicationId: this.getKioskProfile.data().applicationId,
            actionType: "Session Started",
            applicationSessionId: this.getSessionId,
            timeStamp: date.toISOString(),
            sessionPayload: {
              module: "Default",
              action: "Touch Detected",
              response: "User Session Started",
              timeStamp: date.toISOString(),
            },
          });
        }
        this.$store.dispatch("addInteractionToPostgres", {
          actionType: "Session Started",
          actionPayload: { recognitionType: "Touch" },
        });
      } else {
        this.$store.commit("setTouchCount", this.getTouchCount + 1);
      }
      date = new Date();
      this.$store.dispatch("addSessionDataToStrapi", {
        applicationId: this.getKioskProfile.data().applicationId,
        actionType: "Touch",
        applicationSessionId: this.getSessionId,
        timeStamp: date.toISOString(),
        sessionPayload: {
          module: "Home Page",
          action: "navigate",
          response: "Demo Mode Passcode Dialog",
          timeStamp: date.toISOString(),
        },
      });

      this.$store.dispatch("addInteractionToPostgres", {
        actionType: "Interaction",
        actionPayload: {
          module: "Home Page",
          navigateFrom: "Home Page",
          navigateTo: "Home Page",
          interactionType: "Touch",
          elementContent: "Demo Mode Passcode Dialog",
        },
      });
    },
    appendDigit(digit) {
      if (this.passcode.length < this.passcodeLength) {
        // Limit passcode length
        this.passcode += digit.toString();
        this.showWarning = false;
      }
    },
    deleteLastDigit() {
      this.passcode = this.passcode.slice(0, -1);
      this.showWarning = false;
    },

    submitPasscode() {
      console.log("Entered Passcode:", this.passcode);

      if (this.passcode.length !== this.passcodeLength) {
        this.showWarning = true;
        return;
      }

      if (this.passcode === "1232") {
        window.unloadScene();
        this.$store.commit("setPassCodeDialog", false);
        this.goDemo();
      } else {
        this.showWarning = true;
        this.passcode = "";
      }

      // --- Passcode Validation Logic ---
      // if (this.passcode.length === this.passcodeLength) {
      //   if (this.passcode === "1232") {
      //     window.unloadScene();
      //     this.$store.commit("setPassCodeDialog", false)
      //     this.goDemo();
      //   } else {
      //     this.passcode = "";
      //     this.$store.commit("setPassCodeDialog", false)
      //   }
      // } else {
      //   alert(`Passcode must be ${this.passcodeLength} digits long.`);
      // }
    },
  },
  mounted() {},
};
</script>

<style scoped>
.floating-demo-btn {
  position: fixed;
  top: 60%;
  left: -5px;
  transform: translateY(-50%);
  z-index: 10000;
  transition: left 0.5s ease;
}

/* Also remove global overflow in fullscreen mode */
::v-deep(.v-dialog--fullscreen) {
  overflow: hidden !important;
}

::v-deep .v-dialog--fullscreen {
  margin: 0 !important;
  top: 0 !important;
  left: 0 !important;
  border-radius: 0 !important;
}

::v-deep .v-dialog--fullscreen .v-card {
  height: 100% !important;
  width: 100% !important;
}

.keypad .v-btn {
  min-width: 60px;
  width: 60px;
  height: 60px;
}
.keypad .v-btn .text-h6 {
  font-weight: bold;
}
.text-center {
  text-align: center;
}

/* Iframe container: keeps aspect ratio 16:9 */
.iframe-container {
  position: absolute;
  top: 45%;
  left: 50%;
  width: 1920px;
  height: 1080px;
  transform-origin: center center;
  /* Default scale (1280 / 1920 = 0.6667) */
  transform: translate(-50%, -50%) scale(0.9);
  background: #000;
  overflow: hidden;
  z-index: 1;
}
</style>
